import cardValidator from 'card-validator';

export const CreditCardNumber = () => {
  return {
    restrict: 'A',
    require: 'ngModel',
    link() {
      arguments[3].$validators.creditCardNumber = value => {
        const numberValidation = cardValidator.number(value);
        const isAccepted = /visa|american-express|master-card/.test(
          numberValidation.card && numberValidation.card.type
        );

        return isAccepted && numberValidation.isValid;
      };
    },
  };
};

export const CreditCardDate = () => {
  return {
    restrict: 'A',
    require: 'ngModel',
    link($scope, $element, $attrs, $model) {
      $model.$validators.creditCardDate = value => {
        const { month, year } = $scope.$eval($attrs.creditCardDate);

        if (month && year && month.$viewValue && year.$viewValue) {
          const { isValid } = cardValidator.expirationDate({
            month: month.$viewValue,
            year: year.$viewValue,
          });

          month.$setValidity('creditCardDate', isValid);
          year.$setValidity('creditCardDate', isValid);

          return isValid;
        } else {
          return true;
        }
      };
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/Validators/CreditCard.js